import React, { useContext, useEffect, useState, useRef } from "react";

import "antd/dist/reset.css";
import { Popover as AntdPopover, Dropdown as AntDropDown, message } from "antd";
import "./workdrive.css";
import AwsServerService from "../../common/util/AwsServerService";
import { Modal } from "antd";
import Draggable from "react-draggable";
import { AppDataRequired } from "../../App";

const ROLE_MAP = {
  Admin: 36,
  Organize: 3,
  Edit: 5,
  View: 6,
  //   Upload: 7,
  Restricted: 0,
};

const CustomizeFolder = ({
  data,
  dragDisabled,
  setDragDisabled,
  shareOpen,
  setShareOpen,
  dragRef,
}) => {
  const { AllUsers } = useContext(AppDataRequired);
  const [folderUser, setFolderUser] = useState([]);
  const [confirmCustomizeOpen, setConfirmCustomizeOpen] = useState(false);
  const [customizedConfirmed, setCustomizedConfirmed] = useState(false);
  const [changeAccess, setChangeAccess] = useState(false);
  const [accessId, setAccessId] = useState(6);
  const [searchTerm, setSearchTerm] = useState("");
  const [filteredUsers, setFilteredUsers] = useState([]);
  const [selectedUser, setSelectedUser] = useState(null);
  const [selectedItems, setSelectedItems] = useState(data);
  
  useEffect(() => {
    if (selectedItems.length > 0) {
      fetchFolderMembers(selectedItems[0]?.id);
    }
  }, [selectedItems]);
  
  const usersWithoutAccess = folderUser.filter(
    (user) => !user.hasAccess && !user.isCreator,
  );
  
  useEffect(() => {
    if (searchTerm.trim() === "") {
      setFilteredUsers([]);
    } else {
      const filtered = usersWithoutAccess.filter(
        (user) =>
          user.email.toLowerCase().includes(searchTerm.toLowerCase()) ||
          (user.full_name || "")
            .toLowerCase()
            .includes(searchTerm.toLowerCase()),
      );

      setFilteredUsers(filtered);
    }
  }, [searchTerm, folderUser]);
  
  const getUserThumbnailUrl = (zuid) =>
    "https://contacts.zoho.com/file?ID=" + zuid + "&fs=thumb";

  const handleAddPermission = async (member, newRoleId) => {
    if (!member) return;
    await AwsServerService.givePermissionToUser(
      member,
      newRoleId,
      selectedItems[0]?.id,
      localStorage.getItem("token"),
    ).then((res) => {
      fetchFolderMembers(selectedItems[0]?.id);
      // setSearchTerm("");
      setAccessId(6);
      message.success("Permission Granted");
    });
  };

  const fetchFolderMembers = async (folderId) => {
    const res = await AwsServerService.fetchFolderMembers(
      folderId,
      localStorage.getItem("token"),
    );

    const folderData =
      res?.data?.data?.filter(
        (item) =>
          item?.attributes?.shared_status === "ACTIVE" &&
          item?.attributes?.resource_id === selectedItems[0]?.id,
      ) || [];

    const creator = selectedItems[0]?.attributes?.created_by;
    const folderUserMap = {};
    folderData.forEach((item) => {
      const email = item?.attributes?.email_id;
      if (email) {
        folderUserMap[email] = item;
      }
    });

    let mergedUsers = (AllUsers || []).map((user) => {
      const email = user.email || user.email_id;
      const folderUser = folderUserMap[email];

      return {
        ...user,
        email,
        role_id: folderUser ? folderUser.attributes.role_id : null,
        permissionId: folderUser ? folderUser.id : null,
        hasAccess: !!folderUser,
        isCreator: user.full_name == creator,
        zuid: user?.zuid,
      };
    });
    const creatorExists = mergedUsers.some((u) => u.full_name === creator);

    if (!creatorExists && creator) {
      mergedUsers.push({
        name: creator,
        email: creator.email_id,
        id: creator.id,
        role_id: null,
        hasAccess: true,
        isCreator: true,
      });
    }

    mergedUsers.sort((a, b) => {
      if (a.isCreator) return -1;
      if (b.isCreator) return 1;

      if (a.hasAccess && !b.hasAccess) return -1;
      if (!a.hasAccess && b.hasAccess) return 1;

      return 0;
    });

    setFolderUser(mergedUsers);
  };
  
  const folderCustomize = async (customized) => {
    await AwsServerService.customizeFolder(
      selectedItems[0]?.id,
      customized,
      localStorage.getItem("token"),
    ).then((res) => {
      message.success("Customized folder permission is applied.");
      setSelectedItems((prev) =>
        prev.map((item, index) =>
          index === 0
            ? {
                ...item,
                attributes: {
                  ...item.attributes,
                  customized: customized,
                },
              }
            : item,
        ),
      );
    });
  };

  const handleRoleChange = async (member, newRoleId) => {
    if (newRoleId == 0) {
      try {
        await AwsServerService.removePermission(
          member?.permissionId,
          localStorage.getItem("token"),
        ).then((res) => {
          fetchFolderMembers(selectedItems[0]?.id);
          message.success("Access Restricted");
        });
      } catch (err) {
        console.error("Delete error:", err);
      }
    } else {
      AwsServerService.updateMemberRole(
        member,
        newRoleId,
        localStorage.getItem("token"),
      )
        .then((res) => {
          fetchFolderMembers(selectedItems[0]?.id);
          message.success("User Role Updated");
        })
        .catch((err) => {});
    }
  };

  return (
    <>
      <Modal
      styles={{left:"-20%"}}
        title={
          <div
            style={{ cursor: "move" }}
            onMouseOver={() => setDragDisabled(false)}
            onMouseOut={() => setDragDisabled(true)}
          >
            {changeAccess == true
              ? "Change Access 📁 "
              : customizedConfirmed == true
                ? "Customize folder permissions 📁 "
                : "Share 📁 "}

            {selectedItems.length === 1
              ? selectedItems[0]?.attributes?.name
              : `${selectedItems.length} items selected`}
            {selectedItems.length === 1 &&
            selectedItems[0]?.attributes?.customized ? (
              <span style={{ marginLeft: "4px", backgroundColor: "#c8c8eb" }}>
                Customized Folder
              </span>
            ) : (
              ""
            )}
          </div>
        }
        open={shareOpen}
        onCancel={() => {
          setShareOpen(false);
          setCustomizedConfirmed(false);
        }}
        footer={
          <div>
            {customizedConfirmed == true ? (
              <div>
                <button
                  style={{
                    padding: "8px 16px",
                    borderRadius: "6px",
                    border: "1px solid #ccc",
                    background: "#fff",
                    cursor: "pointer",
                  }}
                  onClick={() => setCustomizedConfirmed(false)}
                >
                  Close
                </button>
              </div>
            ) : changeAccess == true ? (
              <button
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: "#fff",
                  cursor: "pointer",
                }}
                onClick={() => setChangeAccess(false)}
              >
                Close
              </button>
            ) : (
              ""
            )}
          </div>
        }
        modalRender={(modal) => (
          <Draggable disabled={dragDisabled} nodeRef={dragRef}>
            <div ref={dragRef}>{modal}</div>
          </Draggable>
        )}
      >
        {/* BODY */}
        {customizedConfirmed == false && changeAccess == false ? (
          <>
            <div style={{ display: "flex" }}>
              <div style={{ flex: 1, position: "relative" }}>
                {/* Chips + Input */}
                <div
                  style={{
                    border: "1px solid #d1d5db",
                    borderRadius: "6px",
                    padding: "6px",
                    display: "flex",
                    flexWrap: "wrap",
                    alignItems: "center",
                    gap: "6px",
                    cursor: "text",
                    height: "56px",
                  }}
                  onClick={() => document.getElementById("user-input").focus()}
                >
                  {selectedUser && (
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        background: "#e5e7eb",
                        padding: "4px 8px",
                        borderRadius: "16px",
                        fontSize: "12px",
                      }}
                    >
                      <img
                        src={getUserThumbnailUrl(selectedUser.zuid)}
                        className="User-Image"
                        style={{ marginRight: "6px" }}
                      />
                      {selectedUser.full_name}

                      <span
                        style={{ marginLeft: "6px", cursor: "pointer" }}
                        onClick={(e) => {
                          e.stopPropagation();
                          setSelectedUser(null);
                          setSearchTerm("");
                        }}
                      >
                        ✕
                      </span>
                    </div>
                  )}

                  <input
                    id="user-input"
                    type="text"
                    value={searchTerm}
                    onChange={(e) => {
                      setSearchTerm(e.target.value);
                      setSelectedUser(null);
                    }}
                    placeholder={!selectedUser ? "Add members..." : ""}
                    style={{
                      border: "none",
                      outline: "none",
                      flex: 1,
                      minWidth: "120px",
                    }}
                  />
                </div>

                {filteredUsers.length > 0 && (
                  <div
                    style={{
                      position: "absolute",
                      top: "110%",
                      width: "100%",
                      background: "#fff",
                      border: "1px solid #ddd",
                      borderRadius: "6px",
                      maxHeight: "200px",
                      overflowY: "auto",
                      zIndex: 1000,
                    }}
                  >
                    {filteredUsers
                      .filter((user) => !user.hasAccess && !user.isCreator)
                      .map((user) => (
                        <div
                          key={user.email}
                          onClick={() => {
                            setSelectedUser(user);
                            setSearchTerm("");
                            setFilteredUsers([]);
                          }}
                          style={{
                            padding: "8px 12px",
                            cursor: "pointer",
                            borderBottom: "1px solid #f1f1f1",
                            display: "flex",
                            alignItems: "center",
                            gap: "8px",
                          }}
                        >
                          <img
                            className="User-Image"
                            src={getUserThumbnailUrl(user.zuid)}
                          />
                          {user.full_name || user.name}
                        </div>
                      ))}
                  </div>
                )}
              </div>
              <select
                value={accessId}
                onChange={(e) => setAccessId(e.target.value)}
                style={{
                  height: "56px",
                  width: "15%",
                  padding: "10px",
                  borderRadius: "6px",
                  border: "1px solid #d1d5db",
                  background: "#fff",
                }}
              >
                {Object.entries(ROLE_MAP).map(([label, id]) => (
                  <option key={id} value={id}>
                    {label}
                  </option>
                ))}
              </select>
              <button
                onClick={() => {
                  if (!selectedUser) {
                    message.warning("Please select a user");
                    return;
                  }

                  handleAddPermission(selectedUser, accessId);
                  setSelectedUser(null);
                  setSearchTerm("");
                }}
                style={{
                  height: "56px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  padding: "10px 16px",
                  borderRadius: "6px",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Share
              </button>
              <hr />
            </div>
            <div>
              <b>Who can access</b>
              <div
                style={{
                  backgroundColor: "#f5f6f7",
                  padding: "16px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  border: "1px solid #e0e0e0",
                }}
              >
                {selectedItems.length === 1 &&
                selectedItems[0]?.attributes?.customized ? (
                  <>
                    <p
                      style={{
                        margin: 0,
                        color: "#333",
                        fontSize: "14px",
                        lineHeight: "1.5",
                      }}
                    >
                      This is a customized folder, so Team Folder and parent
                      folder permissions won't apply to it.{" "}
                      <span
                        style={{ color: "#0b65c2", cursor: "pointer" }}
                        onClick={() =>
                          window.open(
                            "https://help.zoho.com/portal/en/kb/workdrive/team-folder-basics/articles/customize-folder-permissions-in-a-team-folder",
                            "_blank",
                          )
                        }
                      >
                        Learn more about custom folder permissions.
                      </span>
                    </p>

                    <button
                      onClick={() => {
                        folderCustomize(false);
                      }}
                      style={{
                        marginLeft: "16px",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: "1px solid #1976d2",
                        backgroundColor: "#e3f2fd",
                        color: "#1976d2",
                        fontWeight: "500",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Remove Customization
                    </button>
                  </>
                ) : (
                  <>
                    <p
                      style={{
                        margin: 0,
                        color: "#333",
                        fontSize: "14px",
                        lineHeight: "1.5",
                      }}
                    >
                      Restrict access to parent folder collaborators, or change
                      their access levels by{" "}
                      <span
                        style={{ color: "#0b65c2", cursor: "pointer" }}
                        onClick={() =>
                          window.open(
                            "https://help.zoho.com/portal/en/kb/workdrive/team-folder-basics/articles/customize-folder-permissions-in-a-team-folder",
                            "_blank",
                          )
                        }
                      >
                        customizing folder permissions.
                      </span>
                    </p>

                    <button
                      onClick={() => setConfirmCustomizeOpen(true)}
                      style={{
                        marginLeft: "16px",
                        padding: "8px 16px",
                        borderRadius: "6px",
                        border: "1px solid #1976d2",
                        backgroundColor: "#e8ecf5",
                        color: "#1976d2",
                        fontWeight: "500",
                        cursor: "pointer",
                        whiteSpace: "nowrap",
                      }}
                    >
                      Customize
                    </button>
                  </>
                )}
              </div>
              <div
                style={{
                  marginTop: "12px",
                  display: "flex",
                  flexDirection: "column",
                  gap: "12px",
                }}
              >
                {/* Row 1 */}
                {selectedItems[0]?.attributes?.customized && (
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "space-between",
                      padding: "12px 16px",
                      borderRadius: "10px",
                      backgroundColor: "#f5f6f7",
                      border: "1px solid #e0e0e0",
                    }}
                  >
                    <div
                      style={{
                        display: "flex",
                        alignItems: "center",
                        gap: "12px",
                      }}
                    >
                      <div
                        style={{
                          width: "36px",
                          height: "36px",
                          borderRadius: "8px",
                          backgroundColor: "#e0e0e0",
                          display: "flex",
                          alignItems: "center",
                          justifyContent: "center",
                          fontSize: "16px",
                        }}
                      >
                        📁
                      </div>

                      <div>
                        <div
                          style={{
                            fontSize: "14px",
                            fontWeight: "500",
                            color: "#333",
                          }}
                        >
                          {selectedItems[0]?.attributes?.customized ? (
                            <>
                              {
                                "Selected members of 'Zoho CRM - Workdrive' Team Folder"
                              }
                            </>
                          ) : (
                            <>
                              {"Members of 'Zoho CRM - Workdrive' Team Folder"}
                            </>
                          )}
                        </div>
                        <div style={{ fontSize: "12px", color: "#777" }}>
                          {selectedItems[0]?.attributes?.customized ? (
                            <>{""}</>
                          ) : (
                            <>{"2 Members"}</>
                          )}
                        </div>
                      </div>
                    </div>

                    <button
                      onClick={() => {
                        setChangeAccess(true);
                      }}
                      style={{
                        padding: "6px 14px",
                        borderRadius: "8px",
                        border: "1px solid #c7c7c7",
                        backgroundColor: "#fff",
                        cursor: "pointer",
                        fontSize: "13px",
                        display: "flex",
                        alignItems: "center",
                        gap: "6px",
                      }}
                    >
                      ✏️ Change access
                    </button>
                  </div>
                )}
                {/* Row 2 */}
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    backgroundColor: "#f5f6f7",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "8px",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      📂
                    </div>

                    <div>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333",
                        }}
                      >
                        Collaborators of parent folder{" "}
                        <span style={{ textDecoration: "underline" }}>
                          Deals
                        </span>
                      </div>
                      <div style={{ fontSize: "12px", color: "#777" }}>
                        1 Member
                      </div>
                    </div>
                  </div>

                  <button
                    style={{
                      padding: "6px 14px",
                      borderRadius: "8px",
                      border: "1px solid #c7c7c7",
                      backgroundColor: "#fff",
                      cursor: "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    ✏️ Change access
                  </button>
                </div> */}

                {/* Row 3 */}
                {/* <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    padding: "12px 16px",
                    borderRadius: "10px",
                    backgroundColor: "#f5f6f7",
                    border: "1px solid #e0e0e0",
                  }}
                >
                  <div
                    style={{
                      display: "flex",
                      alignItems: "center",
                      gap: "12px",
                    }}
                  >
                    <div
                      style={{
                        width: "36px",
                        height: "36px",
                        borderRadius: "8px",
                        backgroundColor: "#e0e0e0",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                      }}
                    >
                      🔗
                    </div>

                    <div>
                      <div
                        style={{
                          fontSize: "14px",
                          fontWeight: "500",
                          color: "#333",
                        }}
                      >
                        Permalink - Team Folder members and shared ...
                      </div>
                    </div>
                  </div>

                  <button
                    style={{
                      padding: "6px 14px",
                      borderRadius: "8px",
                      border: "1px solid #c7c7c7",
                      backgroundColor: "#fff",
                      cursor: "pointer",
                      fontSize: "13px",
                      display: "flex",
                      alignItems: "center",
                      gap: "6px",
                    }}
                  >
                    ⚙️ Change visibility
                  </button>
                </div> */}
              </div>
            </div>
          </>
        ) : (
          <>
            <div>
              <input
                placeholder="Search members and groups"
                style={{
                  width: "100%",
                  padding: "10px 14px",
                  borderRadius: "8px",
                  border: "1px solid #d1d5db",
                  marginBottom: "16px",
                }}
              />

              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  padding: "8px 16px",
                  color: "#6b7280",
                  fontSize: "13px",
                  borderBottom: "1px solid #e5e7eb",
                  fontWeight: "500",
                }}
              >
                <div style={{ flex: 1 }}>Name</div>
                <div style={{ width: "150px", textAlign: "right" }}>
                  Access Level
                </div>
              </div>
            </div>
            <div style={{ maxHeight: "300px", overflowY: "auto" }}>
              {folderUser.map((member, idx) => {
                return (
                  <div
                    key={idx}
                    style={{
                      display: "flex",
                      alignItems: "center",
                      padding: "12px 16px",
                      borderBottom: "1px solid #f1f1f1",
                    }}
                  >
                    <img
                      className="User-Image"
                      src={getUserThumbnailUrl(member.zuid)}
                    />
                    <div style={{ flex: 1 }}>
                      <div style={{ fontWeight: "500", fontSize: "14px" }}>
                        {member.name || member.full_name}
                        {member.isCreator && (
                          <span
                            style={{
                              marginLeft: "6px",
                              color: "#1976d2",
                              fontSize: "12px",
                            }}
                          >
                            (Owner)
                          </span>
                        )}
                      </div>

                      <div style={{ fontSize: "12px", color: "#6b7280" }}>
                        {member.email}
                      </div>
                    </div>

                    <div style={{ width: "150px", textAlign: "right" }}>
                      {member.isCreator ? (
                        <span
                          style={{ color: "#6b7280", fontWeight: "500" }}
                        ></span>
                      ) : member.hasAccess ? (
                        <select
                          value={member.role_id || ""}
                          onChange={(e) =>
                            handleRoleChange(member, parseInt(e.target.value))
                          }
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "6px 10px",
                            fontSize: "13px",
                            background: "#fff",
                          }}
                        >
                          {Object.entries(ROLE_MAP).map(([label, id]) => (
                            <option key={id} value={id}>
                              {label}
                            </option>
                          ))}
                        </select>
                      ) : (
                        <select
                          value={member.role_id ?? 0}
                          onChange={(e) =>
                            handleAddPermission(
                              member,
                              parseInt(e.target.value),
                            )
                          }
                          style={{
                            border: "1px solid #ddd",
                            borderRadius: "8px",
                            padding: "6px 10px",
                            fontSize: "13px",
                            background: "#fff",
                          }}
                        >
                          {Object.entries(ROLE_MAP).map(([label, id]) => (
                            <option key={id} value={id}>
                              {label}
                            </option>
                          ))}
                        </select>
                      )}
                    </div>
                  </div>
                );
              })}
            </div>
          </>
        )}
      </Modal>

      <Modal
        style={{ width: "500px !important", left: "106px" }}
        open={confirmCustomizeOpen}
        onCancel={() => setConfirmCustomizeOpen(false)}
        footer={null}
        centered
      >
        <div style={{ display: "flex", gap: "12px" }}>
          <div style={{ fontSize: "22px", color: "#d97706" }}>⚠️</div>

          <div>
            <div
              style={{
                fontSize: "18px",
                fontWeight: "600",
                marginBottom: "8px",
              }}
            >
              Customize folder permissions?
            </div>

            <div style={{ fontSize: "14px", color: "#444", lineHeight: "1.6" }}>
              Team Folder and parent folder permissions won't apply to this
              folder. Any new members you add to the Team Folder or parent
              folder won't have access to this folder by default.
              <br />
              <br />
              <b>Note:</b> Folder customization does not affect the access
              provided via permalink settings, external links, download links,
              or embed codes.
              <br />
              <br />
              <span
                style={{ color: "#0b65c2", cursor: "pointer" }}
                onClick={() =>
                  window.open(
                    "https://help.zoho.com/portal/en/kb/workdrive/team-folder-basics/articles/customize-folder-permissions-in-a-team-folder",
                    "_blank",
                  )
                }
              >
                Learn more about custom folder permissions.
              </span>
            </div>

            <div
              style={{
                display: "flex",
                justifyContent: "flex-end",
                marginTop: "20px",
                gap: "10px",
              }}
            >
              <button
                onClick={() => {
                  setCustomizedConfirmed(false);
                  setConfirmCustomizeOpen(false);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  border: "1px solid #ccc",
                  background: "#fff",
                  cursor: "pointer",
                }}
              >
                Cancel
              </button>

              <button
                onClick={() => {
                  setCustomizedConfirmed(true);
                  setConfirmCustomizeOpen(false);
                  folderCustomize(true);
                }}
                style={{
                  padding: "8px 16px",
                  borderRadius: "6px",
                  background: "#1976d2",
                  color: "#fff",
                  border: "none",
                  cursor: "pointer",
                  fontWeight: "500",
                }}
              >
                Continue
              </button>
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default CustomizeFolder;
